'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdGraphicEq = function MdGraphicEq(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.6 16.6h3.4v6.8h-3.4v-6.8z m-6.6 13.4v-20h3.4v20h-3.4z m-20-6.6v-6.8h3.4v6.8h-3.4z m13.4 13.2v-33.2h3.2v33.2h-3.2z m-6.8-6.6v-20h3.4v20h-3.4z' })
        )
    );
};

exports.default = MdGraphicEq;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/graphic-eq.js
// module id = 1078
// module chunks = 36573943044255 79611799117203 213534597649335